
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FeedbackFormValues } from './schema';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';

interface ImprovementsTabProps {
  form: UseFormReturn<FeedbackFormValues>;
}

const ImprovementsTab = ({ form }: ImprovementsTabProps) => {
  return (
    <FormField
      control={form.control}
      name="improvements"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Axes d'amélioration</FormLabel>
          <FormControl>
            <Textarea 
              placeholder="Décrivez les points à améliorer..."
              className="resize-none min-h-[200px]"
              {...field}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default ImprovementsTab;
